import React, { useState } from 'react';

const CardGridBlock = ({ block }) => {
  const [playingAudio, setPlayingAudio] = useState(null);
  const audioRefs = {};

  if (!block.cards || block.cards.length === 0) return null;

  const handleCardClick = (card) => {
    if (card.clickable && card.audio && card.onClick === 'playAudio') {
      const audioId = card.audio.id;
      const audioElement = audioRefs[audioId];
      
      if (audioElement) {
        if (playingAudio === audioId) {
          audioElement.pause();
          setPlayingAudio(null);
        } else {
          // Stop any currently playing audio
          Object.values(audioRefs).forEach(audio => {
            if (audio && !audio.paused) {
              audio.pause();
            }
          });
          audioElement.play();
          setPlayingAudio(audioId);
        }
      }
    }
  };

  const getCardStyle = (card) => {
    const style = card.style || {};
    const classes = ['transition-all duration-200 flex items-center justify-center'];
    const inlineStyles = {};
    
    if (style.shape === 'circle') {
      classes.push('rounded-full aspect-square');
    } else if (style.shape === 'rectangle' || style.shape === 'rectangular') {
      inlineStyles.borderRadius = '0px';
    } else if (style.shape === 'rounded') {
      classes.push('rounded-lg');
    } else {
      classes.push('rounded-lg');
    }

    if (style.size === 'large') {
      classes.push('p-6');
      const width = style.minWidth || '120px';
      const height = style.minHeight || '120px';
      inlineStyles.minWidth = width;
      inlineStyles.minHeight = height;
      inlineStyles.width = width;
      inlineStyles.height = height;
    } else if (style.size === 'medium') {
      classes.push('p-4');
      const width = style.minWidth || '100px';
      const height = style.minHeight || '100px';
      inlineStyles.minWidth = width;
      inlineStyles.minHeight = height;
      inlineStyles.width = width;
      inlineStyles.height = height;
    } else {
      classes.push('p-4');
      if (style.minWidth) {
        inlineStyles.minWidth = style.minWidth;
        inlineStyles.width = style.minWidth;
      }
      if (style.minHeight) {
        inlineStyles.minHeight = style.minHeight;
        inlineStyles.height = style.minHeight;
      }
    }

    const bgColor = style.backgroundColor || '#1A588B';
    const textColor = style.textColor || 'white';

    return {
      className: classes.join(' '),
      style: {
        backgroundColor: bgColor,
        color: textColor,
        cursor: card.clickable ? 'pointer' : 'default',
        ...inlineStyles,
      }
    };
  };

  const gridClasses = block.layout === 'horizontal' 
    ? `grid grid-cols-${block.columns || 3} gap-12 mb-6`
    : `flex flex-col gap-12 mb-6`;

  return (
    <div className="flex justify-center mb-6">
      <div className={gridClasses}>
        {block.cards.map(card => {
          const { className, style } = getCardStyle(card);
          return (
            <div key={card.id} className="flex flex-col items-center">
              <button
                onClick={() => handleCardClick(card)}
                className={`${className} hover:opacity-90 hover:scale-105`}
                style={style}
              >
                <div className="text-center">
                  <div className="font-bold text-lg">{card.displayText}</div>
                  {card.subText && (
                    <div className="text-sm opacity-90 mt-1">{card.subText}</div>
                  )}
                </div>
              </button>
              {card.audio && card.clickable && (
                <p className="text-xs text-center text-gray-500 mt-2 italic">
                  click to hear
                </p>
              )}
              {card.audio && (
                <audio
                  ref={el => audioRefs[card.audio.id] = el}
                  src={card.audio.url}
                  onEnded={() => setPlayingAudio(null)}
                  preload="metadata"
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CardGridBlock;

